import { get } from 'lodash';
import SHOW_RTE_PAYERS from '../queries/insurance/show-rte-payers';

function getRtePayers(client) {
  return client.query({
    query: SHOW_RTE_PAYERS,
    fetchPolicy: 'network-only'
  }).then(response => get(response, 'data.rtePayers'));
}

export default getRtePayers;
